/* Cart API compartida — PDP + Product Cards
 * add → animação divertida (já no clique) + drawer · buy → /checkout
 */
(function () {
  function getRoutes() {
    var tt = window.TT_PDP || {};
    var root =
      (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ||
      tt.root ||
      '/';
    if (root.slice(-1) !== '/') root += '/';
    var cartFromTheme =
      (window.routes && window.routes.cart_url) || tt.cartUrl || root + 'cart';
    return {
      root: root,
      cart: cartFromTheme,
      checkout: tt.checkoutUrl || root + 'checkout',
      cartAdd: (window.routes && window.routes.cart_add_url) || root + 'cart/add.js',
    };
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function prefersReducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function pulseCartIcon() {
    var icon = document.querySelector('#cart-icon-bubble');
    if (!icon) return;
    icon.classList.remove('tt-cart-icon--pulse');
    void icon.offsetWidth;
    icon.classList.add('tt-cart-icon--pulse');
    window.setTimeout(function () {
      icon.classList.remove('tt-cart-icon--pulse');
    }, 750);
  }

  function spawnSparks(x, y) {
    if (prefersReducedMotion()) return;
    var wrap = document.createElement('div');
    wrap.className = 'tt-cart-sparks';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.style.left = x + 'px';
    wrap.style.top = y + 'px';
    for (var i = 0; i < 5; i++) {
      var s = document.createElement('span');
      s.style.setProperty('--tt-spark-a', i * 72 + 'deg');
      s.style.setProperty('--tt-spark-d', 22 + (i % 3) * 10 + 'px');
      wrap.appendChild(s);
    }
    document.body.appendChild(wrap);
    window.setTimeout(function () {
      wrap.remove();
    }, 550);
  }

  /** Bolinha voa do botão ao ícone (WAAPI em px) — começa já no clique */
  function playAddFlyAnimation(sourceEl) {
    return new Promise(function (resolve) {
      var to = document.querySelector('#cart-icon-bubble');
      if (!to || prefersReducedMotion()) {
        pulseCartIcon();
        window.setTimeout(resolve, 160);
        return;
      }

      var fromRect =
        sourceEl && typeof sourceEl.getBoundingClientRect === 'function'
          ? sourceEl.getBoundingClientRect()
          : {
              left: window.innerWidth / 2 - 16,
              top: window.innerHeight * 0.55,
              width: 32,
              height: 32,
            };
      var toRect = to.getBoundingClientRect();
      var startX = fromRect.left + fromRect.width / 2;
      var startY = fromRect.top + fromRect.height / 2;
      var endX = toRect.left + toRect.width / 2;
      var endY = toRect.top + toRect.height / 2;
      var midX = startX + (endX - startX) * 0.42;
      var midY = Math.min(startY, endY) - 120;
      var dx1 = midX - startX;
      var dy1 = midY - startY;
      var dx2 = endX - startX;
      var dy2 = endY - startY;

      var fly = document.createElement('div');
      fly.className = 'tt-cart-fly is-visible';
      fly.setAttribute('aria-hidden', 'true');
      // Conteúdo mínimo: Dawn (base.css) esconde div:empty com display:none
      fly.textContent = '•';
      fly.style.left = startX + 'px';
      fly.style.top = startY + 'px';
      fly.style.color = 'transparent';
      fly.style.fontSize = '1px';
      fly.style.lineHeight = '40px';
      fly.style.textAlign = 'center';
      document.body.appendChild(fly);

      var done = false;
      function finish() {
        if (done) return;
        done = true;
        if (fly.parentNode) fly.remove();
        pulseCartIcon();
        spawnSparks(endX, endY);
        resolve();
      }

      if (typeof fly.animate === 'function') {
        var anim = fly.animate(
          [
            { transform: 'translate(0, 0) scale(0.55)', opacity: 1, offset: 0 },
            {
              transform: 'translate(' + dx1 + 'px, ' + dy1 + 'px) scale(1.45)',
              opacity: 1,
              offset: 0.42,
            },
            {
              transform: 'translate(' + dx2 + 'px, ' + dy2 + 'px) scale(0.35)',
              opacity: 0.9,
              offset: 1,
            },
          ],
          {
            duration: 920,
            easing: 'cubic-bezier(0.22, 0.85, 0.28, 1)',
            fill: 'forwards',
          }
        );
        window.setTimeout(function () {
          spawnSparks(midX, midY);
        }, 340);
        anim.onfinish = finish;
        anim.oncancel = finish;
        window.setTimeout(finish, 1100);
      } else {
        fly.style.transition = 'transform 0.9s cubic-bezier(0.22, 0.85, 0.28, 1), opacity 0.9s';
        requestAnimationFrame(function () {
          fly.style.transform = 'translate(' + dx2 + 'px, ' + dy2 + 'px) scale(0.35)';
        });
        window.setTimeout(finish, 920);
      }
    });
  }

  function openDrawerFromAddResponse(data) {
    var drawer = getCartDrawer();
    if (!drawer) return;

    // Carrito dejó de estar vacío: sin esto el 1er add abre el drawer con ítems ocultos
    drawer.classList.remove('is-empty');

    drawer.classList.add('tt-cart-drawer--celebrate');
    window.setTimeout(function () {
      drawer.classList.remove('tt-cart-drawer--celebrate');
    }, 900);

    if (data && data.sections && typeof drawer.renderContents === 'function') {
      drawer.renderContents(data);
      return;
    }
    if (typeof drawer.open === 'function') {
      drawer.open(document.querySelector('#cart-icon-bubble'));
    }
  }

  /** Animação no clique + fetch em paralelo → drawer */
  async function addToCart(variantId, quantity, sourceEl) {
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    var routes = getRoutes();
    var drawer = getCartDrawer();
    var sections =
      drawer && typeof drawer.getSectionsToRender === 'function'
        ? drawer.getSectionsToRender().map(function (s) {
            return s.id;
          })
        : ['cart-drawer', 'cart-icon-bubble'];

    var flyPromise = playAddFlyAnimation(sourceEl);

    var res = await fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: qty }],
        sections: sections.join(','),
        sections_url: window.location.pathname,
      }),
    });
    if (!res.ok) {
      await flyPromise.catch(function () {});
      throw new Error('add_failed');
    }
    var data = await res.json();
    if (data.status && data.status >= 400) {
      await flyPromise.catch(function () {});
      throw new Error(data.description || 'add_failed');
    }

    await flyPromise;
    openDrawerFromAddResponse(data);
    return data;
  }

  async function buyNow(variantId, quantity) {
    var qty = Math.max(1, parseInt(quantity, 10) || 1);
    var routes = getRoutes();
    await fetch(routes.root + 'cart/clear.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
    });
    var res = await fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] }),
    });
    if (!res.ok) throw new Error('add_failed');
    window.location.href = routes.checkout;
  }

  function setBtnLoading(btn, loading) {
    if (!btn) return;
    if (loading) {
      btn.disabled = true;
      btn.setAttribute('aria-busy', 'true');
      btn.classList.add('is-loading');
    } else {
      btn.removeAttribute('aria-busy');
      btn.classList.remove('is-loading');
      if (btn.tagName === 'BUTTON') btn.disabled = false;
    }
  }

  /** Feedback breve no CTA Adicionar (idle → Adicionado ✓ → idle) */
  function flashAddSuccess(btn) {
    if (!btn || !btn.hasAttribute('data-tt-card-add')) return;
    var label = btn.querySelector('.tt-card__cta-label');
    var done = btn.getAttribute('data-tt-label-done') || 'Adicionado ✓';
    var idle =
      btn.getAttribute('data-tt-label-idle') ||
      (label ? label.textContent : '') ||
      'Adicionar ao carrinho';
    btn.classList.add('is-success');
    if (label) {
      label.textContent = done;
    } else {
      btn.textContent = done;
    }
    window.setTimeout(function () {
      btn.classList.remove('is-success');
      if (label) {
        label.textContent = idle;
      } else if (btn.hasAttribute('data-tt-label-idle')) {
        btn.textContent = idle;
      }
    }, 1600);
  }

  function onCardActionClick(e) {
    var btn =
      e.target && e.target.closest
        ? e.target.closest('[data-tt-card-add], [data-tt-card-buy]')
        : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    if (btn.disabled || btn.getAttribute('aria-busy') === 'true') return;

    var variantId = parseInt(btn.getAttribute('data-variant-id') || '', 10);
    if (!variantId) return;

    var mode = btn.hasAttribute('data-tt-card-buy') ? 'buy' : 'add';
    var actions = btn.closest('.tt-card__actions');
    var siblings = actions
      ? actions.querySelectorAll('[data-tt-card-add], [data-tt-card-buy]')
      : [btn];

    siblings.forEach(function (b) {
      setBtnLoading(b, true);
    });

    var promise =
      mode === 'buy' ? buyNow(variantId, 1) : addToCart(variantId, 1, btn);

    promise
      .then(function () {
        if (mode === 'add') {
          siblings.forEach(function (b) {
            setBtnLoading(b, false);
          });
          flashAddSuccess(btn);
        }
      })
      .catch(function () {
        siblings.forEach(function (b) {
          setBtnLoading(b, false);
        });
        var err = actions && actions.querySelector('[data-tt-card-error]');
        if (err) {
          err.textContent =
            mode === 'buy'
              ? 'Não foi possível ir ao checkout. Tente novamente.'
              : 'Não foi possível adicionar. Tente novamente.';
          err.hidden = false;
          window.setTimeout(function () {
            err.hidden = true;
          }, 5000);
        }
      });
  }

  document.addEventListener('click', onCardActionClick);

  /* Card de kit: uma chamada com as peças e redirect a /cart. Não abre o drawer. */
  document.addEventListener('click', function (e) {
    var btn =
      e.target && e.target.closest ? e.target.closest('[data-tt-kit-card-buy]') : null;
    if (!btn || btn.disabled || btn.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    e.stopPropagation();

    var actions = btn.closest('.tt-card__actions');
    var dataEl = actions && actions.querySelector('[data-tt-kit-card-data]');
    var err = actions && actions.querySelector('[data-tt-card-error]');
    var data;
    try {
      data = JSON.parse(dataEl ? dataEl.textContent : '');
    } catch (parseErr) {
      data = null;
    }
    var items = (data && data.items) || [];
    if (!items.length) {
      if (err) {
        err.textContent = 'Este kit ainda não tem os produtos vinculados.';
        err.hidden = false;
      }
      return;
    }
    var missing = items.filter(function (item) {
      return item.available === false;
    });
    if (missing.length) {
      if (err) {
        err.textContent =
          'Não foi possível montar o kit. Sem estoque: ' +
          missing
            .map(function (item) {
              return item.title;
            })
            .join(', ') +
          '.';
        err.hidden = false;
      }
      return;
    }

    var label = btn.querySelector('[data-tt-kit-label]');
    var idle = label ? label.textContent : 'Comprar kit';
    setBtnLoading(btn, true);
    if (label) label.textContent = 'Adicionando…';

    var instance =
      window.crypto && typeof crypto.randomUUID === 'function'
        ? crypto.randomUUID()
        : 'kit-' + Date.now().toString(36);
    var routes = getRoutes();
    fetch(routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: items.map(function (item) {
          return {
            id: item.id,
            quantity: 1,
            properties: {
              _kit_name: data.kitName,
              _kit_id: String(data.kitId),
              _kit_url: data.kitUrl || '',
              _kit_instance: instance,
            },
          };
        }),
      }),
    })
      .then(function (res) {
        return res.json().then(function (json) {
          return { ok: res.ok, json: json };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          setBtnLoading(btn, false);
          if (label) label.textContent = idle;
          if (err) {
            err.textContent =
              (result.json && (result.json.description || result.json.message)) ||
              'Não foi possível adicionar o kit. Tente de novo.';
            err.hidden = false;
          }
          return;
        }
        window.location.assign(routes.cart);
      })
      .catch(function () {
        setBtnLoading(btn, false);
        if (label) label.textContent = idle;
        if (err) {
          err.textContent = 'Não foi possível adicionar o kit. Verifique a conexão e tente de novo.';
          err.hidden = false;
        }
      });
  });

  window.TTCart = {
    getRoutes: getRoutes,
    addToCart: addToCart,
    buyNow: buyNow,
    openDrawer: function () {
      var drawer = getCartDrawer();
      if (drawer && typeof drawer.open === 'function') {
        drawer.open(document.querySelector('#cart-icon-bubble'));
      }
    },
  };
})();
